document.addEventListener('click', (event) => {
  const openDialog = event.target.closest('[data-fw-open-dialog]');
  if (openDialog) document.getElementById(openDialog.dataset.fwOpenDialog)?.showModal();
  const closeDialog = event.target.closest('[data-fw-close-dialog]');
  if (closeDialog) closeDialog.closest('dialog').close();
  const button = event.target.closest('[data-fw-gallery-image]');
  if (button) {
    const gallery = button.closest('[data-fw-gallery]');
    const main = gallery.querySelector('[data-fw-gallery-main]');
    // Each responsive gallery selection supplies its own candidates.
    // Clear candidates for older galleries so the previous image cannot persist.
    main.srcset = button.dataset.fwGallerySrcset || "";
    main.src = button.dataset.fwGalleryImage;
    main.alt = button.dataset.fwGalleryAlt;
    for (const sibling of gallery.querySelectorAll('[data-fw-gallery-image]')) sibling.setAttribute('aria-pressed', String(sibling === button));
  }
  const reviewLink = event.target.closest('[data-fw-open-reviews]');
  if (reviewLink) {
    const reviews = document.getElementById(reviewLink.dataset.fwOpenReviews);
    if (reviews) reviews.open = true;
  }
});

// Touch navigation for both product galleries, including dynamically shown products.
(() => {
  let gesture = null;
  let suppressedClick = null;
  const mainSelector = '.fw-gallery-main, [data-pouch-open]';

  document.addEventListener('pointerdown', event => {
    suppressedClick = null;
    if (event.pointerType !== 'touch' || !event.isPrimary) {
      gesture = null;
      return;
    }
    const surface = event.target.closest(mainSelector);
    const gallery = surface?.closest('[data-fw-gallery], fw-pouch-gallery');
    const buttons = gallery ? [...gallery.querySelectorAll('[data-fw-gallery-image], [data-pouch-image]')] : [];
    gesture = buttons.length > 1 ? {
      pointerId: event.pointerId,
      surface,
      buttons,
      x: event.clientX,
      y: event.clientY
    } : null;
  }, { passive: true });

  document.addEventListener('pointermove', event => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    const dx = Math.abs(event.clientX - gesture.x);
    const dy = Math.abs(event.clientY - gesture.y);
    // Once a gesture starts vertically, leave it entirely to page scrolling.
    if (dy > 10 && dy >= dx) gesture = null;
  }, { passive: true });

  document.addEventListener('pointerup', event => {
    if (!gesture || event.pointerId !== gesture.pointerId) return;
    const { surface, buttons, x, y } = gesture;
    gesture = null;
    const dx = event.clientX - x;
    const dy = event.clientY - y;
    if (Math.abs(dx) <= 10 || Math.abs(dx) <= Math.abs(dy) * 1.25) return;
    // A drag must never open the zoom dialog through a compatibility click.
    suppressedClick = { surface, until: performance.now() + 700 };
    if (Math.abs(dx) < 40) return;
    const current = Math.max(0, buttons.findIndex(button => button.getAttribute('aria-pressed') === 'true'));
    const next = buttons[(current + (dx < 0 ? 1 : -1) + buttons.length) % buttons.length];
    next.click();
    const track = next.closest('.fw-gallery-thumbs, [data-pouch-thumbs]');
    if (!track) return;
    const itemRect = next.getBoundingClientRect();
    const trackRect = track.getBoundingClientRect();
    if (itemRect.left < trackRect.left || itemRect.right > trackRect.right) {
      track.scrollBy({ left: itemRect.left - trackRect.left - (track.clientWidth - itemRect.width) / 2, behavior: 'auto' });
    }
  }, { passive: true });

  document.addEventListener('pointercancel', () => { gesture = null; }, { passive: true });
  document.addEventListener('click', event => {
    if (!suppressedClick || performance.now() > suppressedClick.until || event.detail === 0) return;
    if (!suppressedClick.surface.contains(event.target)) return;
    suppressedClick = null;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();

// The store's existing review app injects its widget after page load.
// Keep that widget inside this theme's review accordion without changing app settings.
const reviewHost = document.querySelector('[data-fw-review-host]');
if (reviewHost && !reviewHost.querySelector('[data-fw-native-reviews]')) {
  const syncReviews = () => {
    const widget = document.querySelector('.ez-amrv-wrapp');
    if (!widget) return;
    if (widget.parentElement !== reviewHost) reviewHost.append(widget);
    reviewHost.querySelector('[data-fw-review-fallback]').hidden = true;
    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      const value = node.nodeValue;
      const translated = value.replace(/Based on (\d+) reviews/g, 'Basierend auf $1 Bewertungen').replace('See all photos', 'Alle Fotos ansehen').replace('WRITE A REVIEW', 'BEWERTUNG SCHREIBEN');
      if (translated !== value) node.nodeValue = translated;
    }
  };
  let pending = false;
  new MutationObserver(() => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; syncReviews(); });
  }).observe(document.querySelector('main'), {childList:true,subtree:true});
  syncReviews();
}
